import React, { useEffect , useState } from 'react';
import {
  Box,
  FormControl,
  Divider,
  Typography,
  Radio,
  List,
  ListItem,
  Avatar,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';
import { useSelector } from 'react-redux';

import { useDispatch } from 'react-redux';
import {
  listApprovalLine,
  unloadApprovalLine,
} from '../../../modules/empModule/empApproval';


const OrderBookApprovalForm = ({ apprUuid, setApprUuid, type }) => {
  const dispatch = useDispatch();
  
  
  const handleChange = (event) => {
    setApprUuid(event.target.value);
  };

  const {  user, approvalLines, error, loading } = useSelector(
    ({ auth, projectModule, empModule, loading }) => ({
      user: auth.user, //user정보
      approvalLines: empModule.employeeApproval.approvalLines,
      error: empModule.employeeApproval.error,
      loading: loading['employee/LIST_APPROVAL_LINE'],
    }),
  );

  useEffect(() => {
    dispatch(listApprovalLine());

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadApprovalLine());
    };
  }, [dispatch]);

  // useEffect(() => {
  //   if(approvalLines){
  //     if(apprUuid === null || apprUuid === undefined){
  //       setApprUuid(approvalLines[0].apprUuid);
  //     }
  //   }
  // }, [approvalLines,apprUuid ]);
  

 
  

  if (loading || !approvalLines) {
    return <div>로딩중</div>;
  }


  return (
    <>
      <Box sx={{ my: 1, px: 2 }}>
      <Typography sx={{ mt: 1, mb: 1 }} variant="subtitle1" component="div">
        결재내역 선택
      </Typography>
        {approvalLines &&
          approvalLines.map((line, index) => (
            <div key={index}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  my:1
                }}
              >
                <Box>
                  <Radio
                    checked={apprUuid === line.apprUuid}
                    onChange={handleChange}
                    value={line?.apprUuid}
                    name={line?.apprNm}
                    inputProps={{ 'aria-label': `${line.apprNm}` }}
                  />
                </Box>
                <Box>
                <Typography variant="subtitle2" gutterBottom component="div">{line.apprNm}</Typography>
                </Box>
              </Box>
              <List
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  padding: 0,
                }}
                component="div"
                aria-labelledby="approval-list-subheader"
              >
                <ListItem>
                  <ListItemAvatar>
                    <Avatar src={line?.usrUuid1Profile}></Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={line?.usrUuid1Nm} secondary="결재자1" />
                  {line.usrUuid2 && (
                    <>
                      <ListItemAvatar>
                        <Avatar src={line?.usrUuid2Profile}></Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={line?.usrUuid2Nm} secondary="결재자2" />
                    </>
                  )}
                  {line.usrUuid3 && (
                    <>
                      <ListItemAvatar>
                        <Avatar src={line?.usrUuid3Profile}></Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={line?.usrUuid3Nm} secondary="결재자3"  />
                    </>
                  )}
                  {line.usrUuid4 && (
                    <>
                      <ListItemAvatar>
                        <Avatar src={line?.usrUuid4Profile}></Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={line?.usrUuid4Nm} secondary="결재자4"  />
                    </>
                  )}
                  {line.usrUuid5 && (
                    <>
                      <ListItemAvatar>
                        <Avatar src={line?.usrUuid5Profile}></Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={line?.usrUuid5Nm} secondary="결재자5"  />
                    </>
                  )}
                </ListItem>
              </List>
              <Divider />
            </div>
          ))}
      </Box>
    </>
  );
};

export default OrderBookApprovalForm;
